import axios from 'axios';

const apiUrl = process.env.BASE_URL || "https://futebol-manager-backend.vercel.app"

const api = axios.create({
  baseURL: apiUrl,
});

export const setToken = (token) => {
  api.defaults.headers.common.Authorization = token;
};

export const requestData = async (endpoint) => {
  const { data } = await api.get(endpoint);
  return data;
};

export const requestLogin = async (endpoint, body) => {
  const { data } = await api.post(endpoint, body);
  return data;
};

export default api;
